import { SVGProps } from 'react';

const SvgLinkSimpleSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L532.4 392c45.4-28.2 75.6-78.6 75.6-136 0-88.4-71.6-160-160-160h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h72c61.9 0 112 50.1 112 112 0 46.6-28.5 86.6-69.1 103.5L389.5 280H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-95.7L216 144h48c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72c-11.3 0-22.3 1.2-32.9 3.4L38.8 5.1zm69.6 176.3-37.7-29.7C46.6 179.7 32 216.1 32 256c0 88.4 71.6 160 160 160h72c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72c-61.9 0-112-50.1-112-112 0-28.6 10.7-54.8 28.4-74.6z" />
  </svg>
);
export default SvgLinkSimpleSlash;
